export default __webpack_public_path__ + "static/media/DeleteFamilyVariant.9c222862.svg";